import { Form, Input, message, Radio, Upload } from 'antd'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useCreateAttachmentDetail } from './utils'
import { CheckCircleOutlined, CloseCircleOutlined, WarningFilled } from '@ant-design/icons'
const { useForm } = Form
import { IconFont, SvgIcon } from '@/components'
import { Message } from '@/components/message'
import { t } from '@/i18n'
export const CreateAccessory = props => {
  const { submit, acquire, form } = props
  const [fileName, setFileName] = useState('')
  const [fileList, setFileList] = useState([])
  const [uploadStatus, setUploadStatus] = useState(false)
  const [createAttachmentDetail] = useCreateAttachmentDetail()
  const [suffix, setSuffix] = useState('')
  const inputContentRef = useRef(fileName)
  const onFinish = (values: any) => {
    console.log(values)
    const { file, attachment_record } = values
    const is_replace = attachment_record === 0 ? false : true
    const formData = new FormData()
    file?.forEach(item => {
      formData.append('file', item.originFileObj)
    })
    formData.append('attachment_name', fileName)
    formData.append('is_replace', is_replace)
    createAttachmentDetail(formData)
      .then(() => {
        acquire()
        form.resetFields()
      })
      .catch(() => {})
    setFileList([])
  }
  useEffect(() => {
    if (submit?.accomplish) {
      if (fileName === '') {
        Message.error('请上传文件')
        return
      }
      form.submit()
      return
    }
    form.resetFields()
  }, [submit.timestamp])
  const [isEditGroupName, setIsEditGroupName] = useState({ visible: false, text: '' })
  return (
    <FomrType onFinish={onFinish} form={form} initialValues={{ attachment_record: 0 }}>
      <Form.Item
        label="附件"
        valuePropName="fileList"
        name="file"
        getValueFromEvent={e => e?.fileList}
        rules={[{ required: true, message: '请添加附件' }]}
        style={{ marginBottom: 8 }}
      >
        <Upload
          beforeUpload={file => {
            const reg = /\.exe|\.pdf|\.docx|\.doc|\.xlsx|\.xls|\.rtf|\.pptx|\.ppt$/
            if (!reg.test(file.name)) {
              setUploadStatus(true)
              setFileName('')
              Message.error('附件格式有误')
              return Upload.LIST_IGNORE
            }
            if (file.size / 1024 / 1024 > 10) {
              Message.error('附件大小不能超过10M')
              setUploadStatus(true)
              setFileName('')
              return Upload.LIST_IGNORE
            }
            setFileName(file.name.substring(0, file.name.lastIndexOf('.')))
            setSuffix(file.name.substring(file.name.lastIndexOf('.')))
            setUploadStatus(false)
            return false
          }}
          showUploadList={false}
          maxCount={1}
          fileList={fileList}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {uploadStatus ? (
              fileName === '' && (
                <UploadError>
                  <WarningFilled />
                  <div style={{ marginLeft: 6 }}>{t('上传失败')}</div>
                </UploadError>
              )
            ) : fileName === '' ? (
              <UploadData>
                <IconFont type="icon-fujian6" />
                <div style={{ marginLeft: 6 }}>{t('未上传')}</div>
              </UploadData>
            ) : (
              <UploadData>
                {isEditGroupName.visible ? (
                  <>
                    <Input
                      placeholder="请输入"
                      onClick={e => e.stopPropagation()}
                      onChange={e => {
                        inputContentRef.current = e.target.value
                      }}
                      defaultValue={fileName}
                    />
                  </>
                ) : (
                  <>
                    {suffix === '.exe' ? (
                      <Svg name={'mini_exe'} />
                    ) : suffix === '.pdf' ? (
                      <Svg name="mini_pdf" />
                    ) : suffix === '.docx' || suffix === '.doc' ? (
                      <Svg name="mini_docx" />
                    ) : suffix === '.xls' || suffix === '.xlsx' ? (
                      <Svg name="mini_xlsx" />
                    ) : suffix === '.rtf' ? (
                      <Svg name="mini_rtf" />
                    ) : suffix === '.pptx' || suffix === '.ppt' ? (
                      <Svg name="mini_ppt" />
                    ) : (
                      ''
                    )}
                    <div style={{ marginLeft: 6 }}>{fileName}</div>
                  </>
                )}
              </UploadData>
            )}
            {!uploadStatus && fileName !== '' ? (
              <span
                onClick={(e: any) => {
                  e.stopPropagation()
                }}
              >
                {isEditGroupName.visible ? (
                  <CloseCircleOutlined
                    style={{ marginLeft: 16 }}
                    onClick={() => {
                      setIsEditGroupName({ visible: false, text: '' })
                    }}
                  />
                ) : (
                  <IconFont
                    style={{ marginLeft: 16 }}
                    type="icon-huabanfuben"
                    onClick={() => {
                      setIsEditGroupName(origin => ({ ...origin, visible: true }))
                    }}
                  />
                )}
              </span>
            ) : (
              <IconFont type="icon-shangchuan2" style={{ marginLeft: 16 }} />
            )}
            <span
              onClick={(e: any) => {
                e.stopPropagation()
              }}
            >
              {isEditGroupName.visible ? (
                <CheckCircleOutlined
                  style={{ marginLeft: 12 }}
                  onClick={() => {
                    if (inputContentRef.current.length > 50) {
                      Message.error('附件名称最多50字')
                      return
                    }
                    setFileName(inputContentRef.current)
                    setIsEditGroupName({ visible: false, text: '' })
                  }}
                />
              ) : (
                <span>
                  <DeleteIcon
                    style={{ color: fileName !== '' && '#333' }}
                    type="icon-shanchu-m"
                    onClick={(e: any) => {
                      if (!uploadStatus) {
                        setUploadStatus(false)
                        setFileName('')
                      }
                    }}
                  />
                </span>
              )}
            </span>
          </div>
        </Upload>
      </Form.Item>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('支持上传附件格式：EXE，DOC/X，XLS/X，PPT/X，PDF，RTF')}
      </div>
      <Form.Item label={'附件记录'} name="attachment_record">
        <Radio.Group>
          <Radio value={0}>{t('关闭')}</Radio>
          <Radio value={1}>{t('开启')}</Radio>
        </Radio.Group>
      </Form.Item>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('1.默认关闭，关闭时，用户可上传附件实现邮件发送，但无法实现附件打开行为记录')}
      </div>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('2.开启时，需要使用特制附件才可实现附件记录，特制附件模版及使用请联系平台提供方支持')}
      </div>
      <div style={{ color: '#999', fontSize: 12 }}>
        {t('3.开启后，平台会对上传附件中指定内容进行替换，替换后即可实现附件打开行为记录')}
      </div>
    </FomrType>
  )
}

const FomrType = styled(Form)`
  padding-right: 30px;
  .subject {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .ant-input {
    width: 356px;
  }
  .ant-row {
    display: block;
  }
  .ant-upload-list-item-info {
    border-radius: 4px;
    width: 356px !important;
  }
  .ant-upload-list-item {
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
  }
  .ant-form-item-control-input-content {
    position: relative;
  }
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    /* background-color: transparent; */
  }
  .ant-upload-list-item-card-actions {
    display: flex;
    align-items: center;
    padding: 0;
  }
  .ant-upload-list-item-card-actions-btn {
    padding: 0 !important;
  }
  .icon_fujian {
    position: absolute;
    z-index: 9;
    bottom: 8px;
    left: 5px;
    font-size: 20px;
  }
  .ant-upload-text-icon {
    opacity: 0;
    margin-right: 20px;
  }
`
const UploadData = styled.div`
  // width: 210px;
  height: 32px;
  border-radius: 6px;
  background-color: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
`
interface DeleteIconProps {
  upload: boolean
}
const DeleteIcon = styled(IconFont)<DeleteIconProps>`
  margin-left: 14px;
  color: ${props => (props.upload ? '#000' : '#999')};
`
const UploadError = styled.div`
  // width: 210px;
  height: 32px;
  border-radius: 6px;
  background-color: rgba(245, 63, 63, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f53f3f;
`
const Svg = styled(SvgIcon)`
  width: 16px;
  height: 16px;
`
